import {
  Button,
  FormControl,
  Grid,
  InputAdornment,
  InputBase,
  makeStyles,
  withStyles,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
} from "@material-ui/core";
import React, { useState, useMemo, useEffect } from "react";
import SearchIcon from "@material-ui/icons/Search";
import { Pagination, PaginationItem } from "@material-ui/lab";

import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { Select as AntSelect, Checkbox, Divider } from "antd";
import { getPaginationPageNumber } from "../../../shared-resources/utils";
import { CreateUserDialog } from "./CreateUserDialog";
import {
  createUserAPI,
  getUserAPI,
  updateUserAPI,
} from "../../../api/user-management-api";
import { getContractDropdownAPI } from "../../../api/financial-management-api";
import { getRolesAPI } from "../../../api/user-role-api";
import ActionMessages from "../../../common-components/ActionMessages";
import { AntSwitch } from "../../../common-components/AntSwitch";

const UserManagement = () => {
  const useStyles = makeStyles((theme) => ({
    paperTitle: {
      color: "#0070D2",
      fontSize: "16px",
      fontWeight: 600,
      padding: "4px 16px",
      boxShadow: "0px 3px 6px #00000029",
      borderRadius: "8px",
    },
    tablePaper: {
      borderRadius: "12px",
      padding: "12px",
      marginTop: "12px",
    },
    checkCircleIcon: {
      fontSize: "18px",
      color: "#075e07",
      cursor: "pointer",
      marginTop: "2px",
    },
    checkCircleIconSpan: {
      cursor: "pointer",
      marginRight: "2px",
    },
    paginationSection: {
      marginTop: "4px",
    },
    searchSection: {
      marginBottom: "4px",
    },
    searchIcon: {
      color: "#ccc",
    },
    searchTextField: {
      borderRadius: "25px",
      fontSize: "14px",
      height: "36px",
    },
    editIcon: {
      fontSize: "16px",
      color: "#0070D2",
      cursor: "pointer",
    },
    editTextField: {
      height: "24px",
      fontSize: "12px",
      width: "180px",
      padding: "2px",
      background: "#fff",
    },
    editText: {
      padding: "0",
    },
    locationField: {
      height: "36px",
      borderRadius: "25px",
      fontSize: "13px",
    },
    addDialog: {
      width: "350px",
      height: "auto",
      position: "relative",
    },
    addBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      color: "#ffff",
      backgroundColor: "#0176d3",
      borderRadius: "25px",
      margin: "2px 0 2px 15px",
    },
    addRoleBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      color: "#ffff",
      backgroundColor: "#0176d3",
      borderRadius: "25px",
      position: "absolute",
      right: "-32px",
      top: "4px",
    },
    updateBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      color: "#ffff",
      backgroundColor: "#0176d3",
      borderRadius: "25px",
      marginRight: "8px",
    },
    newUserBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      color: "#ffff",
      backgroundColor: "#0176d3",
      borderRadius: "5px",
      marginRight: "8px",
    },
    dropdown: {
      width: "100%",
      maxWidth: "225px",
    },
    departmentDropdownPopup: {
      width: "100%",
    },

    closeSection: {
      position: "absolute",
      cursor: "pointer",
      right: theme.spacing(0.25),
      top: theme.spacing(0.25),
    },
    closeIcon: {
      color: "#C4C4C4",
    },
    drawerDataSection: {
      position: "relative",
      padding: "6px 32px",
    },
    drawerTitle: {
      color: "#0082CA",
      fontSize: theme.spacing(2.25),
      marginBottom: theme.spacing(2),
    },
    uploadDescription: {
      marginBottom: theme.spacing(2),
    },

    addColumnBtn: {
      fontSize: "13px",
      fontWeight: "600",
      padding: "4px 12px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      borderRadius: "15px",
      color: "#3599d1",
      backgroundColor: "#fff !important",
      marginTop: "12px",
    },
    addColumnTitle: {
      height: "28px",
      textAlign: "center",
      marginBottom: "11px",
      fontWeight: 600,
      paddingTop: "5px",
      color: "#ffff",
    },
    closeIconAdd: {
      display: "inline-block",
      color: "black",
      background: "#ffff",
      width: "18px",
      height: "18px",
      borderRadius: "50%",
      cursor: "pointer",
      textAlign: "center",
      position: "absolute",
      top: "5px",
      right: "8px",
      fontSize: "13px",
      fontWeight: 600,
    },
    addDialog: {
      width: "350px",
      height: "auto",
      position: "relative",
    },

    cancelBtn: {
      fontSize: "12px",
      padding: "3px 8px !important",
      textTransform: "none",
      border: "0.5px solid #0176D3",
      color: "#0176D3",
    },
    saveBtn: {
      fontSize: "12px",
      fontWeight: "600",
      padding: "4px 8px !important",
      textTransform: "none",
      border: "1px solid #3599d1",
      color: "#ffff",
      backgroundColor: "#0176d3",
      marginRight: "8px",
    },

    required: {
      color: "red",
    },
    popupBtnsAdd: {
      textAlign: "center",
      marginTop: "24px",
    },
    popupHeader: {
      marginTop: "-20px",
      marginLeft: "-24px",
      marginRight: "-24px",
      background: "#4b5558",
    },
    fieldTitle: {
      fontWeight: 600,
      marginBottom: theme.spacing(0.5),
      fontSize: "13px",
    },
  }));

  const [showDialog, setShowDialog] = useState(false);

  const classes = useStyles();

  const [msg, setMsg] = useState({ type: "", text: "" });
  const [search, setSearch] = useState("");
  const [tableData, setTableData] = useState([]);
  const [updatedTableData, setUpdatedTableData] = useState([]);
  const isDataChanged = useMemo(
    () => JSON.stringify(tableData) != JSON.stringify(updatedTableData),
    [tableData, updatedTableData],
  );
  const dataLength = useMemo(
    () =>
      tableData.filter((td) =>
        (td.firstName + " " + td.lastName)
          .toLowerCase()
          .includes(search.trim().toLowerCase()),
      ).length,
    [tableData, search],
  );

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [roles, setRoles] = useState([]);
  const [contracts, setContracts] = useState([]);

  const onChangeValue = (e, field, id, checkbox) => {
    const changedData = [...tableData];
    changedData.forEach((val) => {
      if (val.userId === id)
        val[field] = checkbox ? e.target.checked : e.target.value;
    });
    setTableData(changedData);
  };

  const onContractChange = (value, tableItem) => {
    const changedData = [...tableData];
    changedData.forEach((val) => {
      if (val.userId === tableItem.userId) val.visibleContracts = value;
    });
    setTableData(changedData);
  };

  const changeEditStatus = (id) => {
    const user = tableData.find((dt) => dt.userId == id);
    const changedData = JSON.parse(JSON.stringify(tableData));
    if (user.isEdit) {
      updateUserAPI([user])
        .then((res) => {
          setMsg({ type: "success", text: "User updated successfully" });
          getUsers();
        })
        .catch((e) => {
          setMsg({ type: "error", text: e });
        });
    } else {
      changedData.forEach((val) => {
        if (val.userId === id) val.isEdit = !val.isEdit;
      });
      setTableData(_.cloneDeep(changedData));
    }
  };

  const onChangeDropdownValue = (field, value, id) => {
    const changedData = JSON.parse(JSON.stringify(tableData));
    changedData.forEach((val) => {
      if (val.userId === id) {
        val[field] = value;
      }
    });
    setTableData(changedData);
  };

  const onChangeRole = (value, id) => {
    onChangeDropdownValue("role", value, id);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onUpdateHandler = () => {
    const changedData = tableData.filter((dt) => dt.isEdit);
    updateUserAPI(changedData)
      .then((res) => {
        const message =
          changedData.length > 1
            ? "Users updated successfully"
            : "User updated successfully";
        setMsg({ type: "success", text: message });
        getUsers();
      })
      .catch((e) => {
        setMsg({ type: "error", text: e });
      });
  };

  const onCancelHandler = () => {
    const updatedData = updatedTableData.map((dt) => ({
      ...dt,
      isEdit: false,
    }));
    setUpdatedTableData(updatedData);
    setTableData(_.cloneDeep(updatedData));
  };

  const onNewUserHandler = () => {
    setShowDialog(true);
  };

  const getUsers = () => {
    setTableData([]);
    setUpdatedTableData([]);
    getUserAPI()
      .then((res) => {
        setTableData(res);
        setUpdatedTableData(res);
      })
      .catch((err) => {
        console.log("users err : ", err);
      });
  };

  const getRoles = () => {
    getRolesAPI()
      .then((res) => {
        setRoles(res);
      })
      .catch((err) => {
        console.log("err : ", err);
      });
  };

  const getContracts = () => {
    getContractDropdownAPI()
      .then((res) => {
        const contractsData = res.data.map((contract) => ({
          value: contract.contractId,
          label: contract.displayName,
        }));
        setContracts(contractsData);
      })
      .catch((err) => {
        console.log("err : ", err);
      });
  };

  const onCreateNewUser = async (newUser) => {
    createUserAPI(newUser)
      .then((res) => {
        console.log("res : ", res);

        setMsg({ type: "success", text: "User created successfully" });
        getUsers();
      })
      .catch((err) => {
        console.log("err : ", err);
        setMsg({ type: "error", text: err });
      });
    // setTableData((data) => [...data, newUser]);
    // setUpdatedTableData((updatedData) => [...updatedData, newUser]);
  };

  const isClosed = () => {
    setMsg({ text: "", type: "" });
  };

  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da !important",
      fontSize: 13,
      padding: "4px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);

  const getContractsDisplayNames = (visibleContracts) => {
    const items = [];
    contracts.forEach((val) => {
      if (visibleContracts.indexOf(val.value) > -1) {
        items.push(val.label);
      }
    });
    return items;
  };

  useEffect(() => {
    getUsers();
    getRoles();
    getContracts();
    return () => {};
  }, []);

  const handleSelectAll = (e, tableItem) => {
    const changedData = [...tableData];
    if (e.target.checked) {
      changedData.forEach((val) => {
        if (val.userId === tableItem.userId)
          val.visibleContracts = contracts.map((c) => c.value);
      });
    } else {
      changedData.forEach((val) => {
        if (val.userId === tableItem.userId) val.visibleContracts = [];
      });
    }
    setTableData(changedData);
  };

  return (
    <div>
      <CreateUserDialog
        roles={roles}
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        onCreateNewUser={onCreateNewUser}
        contracts={contracts}
      />
      <Paper elevation={0} className={classes.tablePaper}>
        <Grid container className={classes.searchSection} spacing={0}>
          <Grid item lg={6}>
            <FormControl variant="outlined" className={classes.searchControl}>
              <OutlinedInput
                className={classes.searchTextField}
                type="text"
                placeholder="Search"
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                endAdornment={
                  <InputAdornment position="start">
                    <SearchIcon className={classes.searchIcon} />
                  </InputAdornment>
                }
              />
            </FormControl>
          </Grid>

          <Grid item lg={6}>
            <Button
              variant="outlined"
              className={classes.cancelBtn}
              color="primary"
              //   onClick={() => cancelUpdate()}
              //   disabled={!isEnabled}
              disabled={!isDataChanged}
              onClick={onCancelHandler}
              style={{ marginTop: "4px", float: "right" }}
            >
              Cancel
            </Button>
            <Button
              className={classes.updateBtn}
              variant="contained"
              color="primary"
              onClick={onUpdateHandler}
              disabled={!isDataChanged}
              //   disabled={!isEnabled}
              style={{ marginTop: "4px", float: "right" }}
            >
              Update
            </Button>
            <Button
              className={classes.newUserBtn}
              variant="contained"
              color="primary"
              onClick={onNewUserHandler}
              //   disabled={!isEnabled}
              style={{ marginTop: "4px", float: "right" }}
            >
              New User
            </Button>
          </Grid>
        </Grid>
        <div style={{ overflowX: "auto" }}>
        <table className="generalSettingsTable">
          <thead>
            <tr>
              <td>S. No.</td>
              <td>First Name</td>
              <td>Last Name</td>
              <td>Email</td>
              <td>Role</td>
              <td>Visible Contracts</td>
              <td>Contract Access</td>
              <td>Indirect Access</td>
              <td>Fringe Access</td>
              <td>Pipeline Access</td>
              <td>Status</td>
            </tr>
          </thead>
          <tbody>
            {tableData
              .filter((td) =>
                (td.firstName + " " + td.lastName)
                  .toLowerCase()
                  .includes(search.trim().toLowerCase()),
              )
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((tableItem, index) => (
                <tr key={index}>
                  <td style={{ display: "flex", alignItems: "center" }}>
                    {tableItem.isEdit ? (
                      <span className={classes.checkCircleIconSpan}>
                        <CheckCircleIcon
                          className={classes.checkCircleIcon}
                          onClick={() => changeEditStatus(tableItem.userId)}
                        />
                      </span>
                    ) : (
                      <span className="settinsTableEdit">
                        <EditIcon
                          className={classes.editIcon}
                          onClick={() => changeEditStatus(tableItem.userId)}
                        />
                      </span>
                    )}
                    <span>{index + 1}</span>
                  </td>
                  <td>
                    <span style={{ float: "left" }}>
                      {tableItem.isEdit ? (
                        <FormControl
                          variant="outlined"
                          className={classes.editText}
                        >
                          <OutlinedInput
                            className={classes.editTextField}
                            type="text"
                            placeholder="First name"
                            onChange={(e) =>
                              onChangeValue(e, "firstName", tableItem.userId)
                            }
                            value={tableItem.firstName}
                            inputProps={{
                              style: {
                                padding: "0 0 0 2px",
                              },
                            }}
                          />
                        </FormControl>
                      ) : (
                        tableItem.firstName
                      )}
                    </span>
                  </td>
                  <td>
                    <span style={{ float: "left" }}>
                      {tableItem.isEdit ? (
                        <FormControl
                          variant="outlined"
                          className={classes.editText}
                        >
                          <OutlinedInput
                            className={classes.editTextField}
                            type="text"
                            placeholder="Last name"
                            onChange={(e) =>
                              onChangeValue(e, "lastName", tableItem.userId)
                            }
                            value={tableItem.lastName}
                            inputProps={{
                              style: {
                                padding: "0 0 0 2px",
                              },
                            }}
                          />
                        </FormControl>
                      ) : (
                        tableItem.lastName
                      )}
                    </span>
                  </td>
                  <td>
                    <span style={{ float: "left" }}>{tableItem.email}</span>
                  </td>

                  <td>
                    {tableItem.isEdit ? (
                      <AntSelect
                        className={classes.dropdown}
                        value={tableItem.role}
                        onChange={(value) =>
                          onChangeRole(value, tableItem.userId)
                        }
                      >
                        {roles.map((role, index) => (
                          <Option key={index} value={role.role}>
                            {role.roleDescription}
                          </Option>
                        ))}
                      </AntSelect>
                    ) : (
                      tableItem.role
                    )}
                  </td>
                  <td>
                    {tableItem.role !== "PC" && tableItem.role !== "SU" && (
                      <>
                        <span style={{ float: "left" }}>
                          {tableItem.isEdit ? (
                            <AntSelect
                              showSearch
                              mode="multiple"
                              size="small"
                              style={{ width: "100%", zIndex: 9 }}
                              placeholder="Search to Select"
                              showArrow
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label.toLowerCase() ?? "").includes(
                                  input.toLowerCase(),
                                )
                              }
                              maxTagCount={5}
                              dropdownRender={(menu) => (
                                <>
                                  <div style={{ padding: "8px 12px" }}>
                                    <Checkbox
                                      onChange={(e) =>
                                        handleSelectAll(e, tableItem)
                                      }
                                      checked={
                                        tableItem.visibleContracts.length ===
                                        contracts.length
                                      }
                                    >
                                      Select All
                                    </Checkbox>
                                  </div>
                                  <Divider style={{ margin: "4px 0" }} />
                                  {menu}
                                </>
                              )}
                              filterSort={(optionA, optionB) =>
                                (optionA?.label ?? "")
                                  .toLowerCase()
                                  .localeCompare(
                                    (optionB?.label ?? "").toLowerCase(),
                                  )
                              }
                              options={contracts}
                              value={
                                tableItem.visibleContracts
                                  ? tableItem.visibleContracts
                                  : []
                              }
                              onChange={(val) =>
                                onContractChange(val, tableItem)
                              }
                            />
                          ) : (
                            getContractsDisplayNames(
                              tableItem.visibleContracts,
                            ).join(",")
                          )}
                        </span>
                      </>
                    )}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Checkbox
                      checked={!!tableItem.contractAccess}
                      disabled={!tableItem.isEdit}
                      onChange={(e) =>
                        onChangeValue(e, "contractAccess", tableItem.userId, true)
                      }
                    />
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Checkbox
                      checked={!!tableItem.indirectAccess}
                      disabled={!tableItem.isEdit}
                      onChange={(e) =>
                        onChangeValue(e, "indirectAccess", tableItem.userId, true)
                      }
                    />
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Checkbox
                      checked={!!tableItem.fringeAccess}
                      disabled={!tableItem.isEdit}
                      onChange={(e) =>
                        onChangeValue(e, "fringeAccess", tableItem.userId, true)
                      }
                    />
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <Checkbox
                      checked={!!tableItem.pipelineAccess}
                      disabled={!tableItem.isEdit}
                      onChange={(e) =>
                        onChangeValue(e, "pipelineAccess", tableItem.userId, true)
                      }
                    />
                  </td>
                  <td>
                    {tableItem.isEdit ? (
                      <AntSwitch
                        checked={!!tableItem.isActive}
                        onChange={(e) =>
                          onChangeValue(e, "isActive", tableItem.userId, true)
                        }
                      />
                    ) : tableItem.isActive ? (
                      "Active"
                    ) : (
                      "Inactive"
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        </div>

        <Grid container className={classes.paginationSection} spacing={0}>
          <Grid item lg={12}>
            <div style={{ float: "right", marginTop: "6px" }}>
              <Pagination
                count={Math.ceil(dataLength / rowsPerPage)}
                showFirstButton
                showLastButton
                page={page + 1}
                onChange={handleChangePage}
                color="primary"
                style={{ float: "right" }}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    page={getPaginationPageNumber(
                      item.page - 1,
                      dataLength,
                      rowsPerPage,
                    )}
                  />
                )}
              />
            </div>
            <div style={{ float: "right", marginTop: "6px" }}>
              <div style={{ float: "left", marginTop: "4px" }}>Showing</div>
              <FormControl className="tableRowsDdl">
                <Select
                  labelId="demo-customized-select-label"
                  id="demo-customized-select"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  input={<BootstrapInput />}
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>15</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                </Select>
              </FormControl>
            </div>
          </Grid>
        </Grid>
      </Paper>

      {msg.text && (
        <ActionMessages
          type={msg.type}
          isClosed={isClosed}
          message={msg.text}
        />
      )}
    </div>
  );
};

export default UserManagement;
